import React from 'react'

export default function ArchiveNoItemicon() {
    return (
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M69 3L3 69" stroke="#292D32" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            <path opacity="0.4" d="M64.642 25.1441V61.4442C64.642 68.0772 59.89 70.8822 54.082 67.6482L32.698 54.2832" stroke="#292D32" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.35962 62.235V15.738C7.35962 8.742 13.0686 3 20.0976 3H51.9426C55.9356 3 59.4996 4.848 61.8426 7.752" stroke="#292D32" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
